import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { KeyboardArrowRight, KeyboardArrowLeft } from '@material-ui/icons';
import TableFormatter from '../../components/TableFormatter';
import Button from '../../components/CustomButtons/Button';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import CategoryRow from './CategoryRow';
import NoContentCard from '../../components/NoContentCard';
import Loading from '../../components/Loading';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import LastPageIcon from '@material-ui/icons/LastPage';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import { allCategories } from '../../dataService/allCategories';

export default () => {
	const classes = useStyles();
	const { push } = useHistory();
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [pageNumber, setPageNumber] = useState(0);
	const [resultCount, setResultCount] = useState(20);
	const [pageCount, setPageCount] = useState(0);

	const tableHead = [
		{ name: 'Name', align: 'left' },
		{ name: 'Source', align: 'left' },
		{ name: 'Action', align: 'left' }
	];
	const [searchTerms, setSearchTerms] = useState({
		_entity: 'Activity',
		_select: '*',
		_page: 1
	});

	const createData = (id, categoryName, source) => {
		return {
			id,
			categoryName,
			source
		};
	};

	const createUserRows = useCallback(async () => {
		setIsLoading(true);
		const res = await allCategories(searchTerms);
		const rows = [];

		if (res.status !== 200) return [];

		res.data.data.forEach((item) => {
			const { id, categoryName, source } = item;
			rows.push(createData(id, categoryName, source));
		});
		const count = Math.ceil(res.data.meta.totalCount / 20);
		setRows(rows);
		setIsLoading(false);
		setPageNumber(res.data.meta.page);
		setResultCount(res.data.meta.resultCount);
		setPageCount(count);
	}, [searchTerms]);

	useEffect(() => {
		createUserRows();
	}, [searchTerms]);

	const prevPage = () => {
		setSearchTerms({
			...searchTerms,
			// eslint-disable-next-line no-underscore-dangle
			...{ _page: searchTerms._page - 1 }
		});
	};

	const nextPage = () => {
		setSearchTerms({
			...searchTerms,
			// eslint-disable-next-line no-underscore-dangle
			...{ _page: searchTerms._page + 1 }
		});
	};

	const lastPage = () => {
		setSearchTerms({
			...searchTerms,
			...{ _page: (searchTerms._page = pageCount) }
		});
	};

	const firstPage = () => {
		setSearchTerms({
			...searchTerms,
			...{ _page: (searchTerms._page = 1) }
		});
	};

	const addCategory = () => {
		push('/addCategory');
	};

	return (
		<>
			<React.Fragment>
				<h3>Categories</h3>
				<Button variant='contained' color='success' onClick={addCategory}>
					Add Category
				</Button>
			</React.Fragment>
			{isLoading && (
				<Loading className={classes.topSpacing} boxHeight='calc(100vh - 120px)' />
			)}

			{!isLoading && !rows.length && (
				<Grid container justify='flex-end' className={classes.topSpacing}>
					<Grid item md={12}>
						<NoContentCard message='No categories found' />
					</Grid>
				</Grid>
			)}

			{rows.length > 0 && !isLoading && (
				<TableFormatter tableHead={tableHead} height='calc(100vh - 150px)'>
					{rows.map((row) => (
						<MuiThemeProvider theme={theme}>
							<CategoryRow key={row.id} {...row} />
						</MuiThemeProvider>
					))}
				</TableFormatter>
			)}
		</>
	);
};

const useStyles = makeStyles({
	topSpacing: {
		marginTop: '30px'
	},
	marginNone: {
		margin: 0
	},
	wrapperCard: {
		marginBottom: 0
	},
	pagination: {
		paddingTop: '15px'
	},
	tableContainer: {
		height: 'calc(100vh - 373px)',
		'& .MuiTableCell-stickyHeader': {
			background: 'white'
		}
	},
	notFoundContainer: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		justifyContent: 'center',
		height: 'calc(100% - 57px)'
	}
});

const theme = createTheme({
	overrides: {
		MuiTableCell: {
			root: {
				paddingTop: 4,
				paddingBottom: 4,
				paddingRight: 5
			}
		}
	}
});
